import React, { useState, useEffect, useContext } from "react";
import "./css/IpoList.css";
import { useNotificationActionsContext } from "../../components/notificationModal/useModal";
import { Context } from "../../services/apiContext";
import configData from "../../utils/config/config.json";

import IPOListing_filters from "./IPOListing_filters";
let PageSize = 10;

const IPOListing = ({ nextStep, prevStep, selectedIpoDetails, goToPage }) => {
  const contextapi = useContext(Context);
  const setNotifi = useNotificationActionsContext();

  const [transactionsList, setTransactionsList] = useState([]);
  const [transactionsListMaster, setTransactionsListMaster] = useState([]);

  const [tabPage, settabPage] = useState("");
  const StepClick = (pagedata,master) => {
    var localmaster = master;
    if (pagedata === "Open") {
      var openData = localmaster.filter(({ OpenStatus }) => OpenStatus === "O");
      setTransactionsList(openData);
    } else if (pagedata === "Upcoming") {
      var upcommingData = localmaster.filter(
        ({ OpenStatus }) => OpenStatus === "U"
      );
      setTransactionsList(upcommingData);
    } else if (pagedata === "Closed") {
      var ClosedData = localmaster.filter(
        ({ OpenStatus }) => OpenStatus === "C"
      );
      setTransactionsList(ClosedData);
    }
    settabPage(pagedata);
    
  };

  const selectedIpoDetailsINter = (that) => {
    console.log(that);
    selectedIpoDetails(that);
  };
  useEffect(() => {
    getIPOList();
  }, []);

  //API LISTING
  const getIPOList = async () => {
    console.log(transactionsListMaster);

    var useData = contextapi.getSession("userData").user_key;

    var postData = {
      user_key: useData,
    };
    var url = "/nse/getipolist";
    await contextapi
      .postApiAuthCalling(url, postData, true)
      .then((res) => {
        console.log(res);
        if (res[0].status_code === "00") {
          setTransactionsListMaster(res[0].ListofIPOs);
          StepClick("Open",res[0].ListofIPOs);
        } else {
          setNotifi({ val: true, msg: res[0].status_desc });
        }
      })
      .catch((error) => {
        console.log(error);
        // setNotifi({ val: true, msg: "Something went wrong" });
      });
  };

  return (
    <div>
      <div className="col-lg-12 col-md-12 col-12 addmargin">
        <h5 className="transactionheader">IPO Listing</h5>
      </div>

      <div className="IPOCard-List">
        <div className="row makerel">
          <div className="makerelnewFlex">
            <div className="flexitems flexitems-1 paddings">
              <button
                type="button"
                className={` tabDesign ${
                  tabPage === "Open" ? " w-15 activeStateIPO" : " w-15"
                }`}
                onClick={() => StepClick("Open",transactionsListMaster)}
              >
                <p>Open</p>{" "}
              </button>
            </div>

            <div className="flexitems paddings">
              <button
                type="button"
                className={` tabDesign ${
                  tabPage === "Upcoming" ? " w-15 activeStateIPO" : " w-15"
                }`}
                onClick={() => StepClick("Upcoming",transactionsListMaster)}
              >
                <p>Upcoming</p>{" "}
              </button>
            </div>

            <div className="flexitems paddings">
              <button
                type="button"
                className={` tabDesign ${
                  tabPage === "Closed" ? " w-15 activeStateIPO" : " w-15"
                }`}
                onClick={() => StepClick("Closed",transactionsListMaster)}
              >
                <p>Closed</p>{" "}
              </button>
            </div>
          </div>
          <div className="underlineipo"></div>
        </div>

          <div className="row makerel">
            <IPOListing_filters
              data={transactionsList}
              prevStep={prevStep}
              tabPage={tabPage}
              nextStep={nextStep}
              selectedIpoDetails={selectedIpoDetailsINter}
              goToPage={goToPage}
              onlyApply
              
            />
          </div>
      
      </div>
    </div>
  );
};

export default IPOListing;
